import { lazy } from 'react';

import { Module, PrivateRoute } from '../../../models/Module';

const ChatListPage = lazy(() => import('pages/ChatListPage'));

export const routes: Module[] = [
    { path: PrivateRoute.Chat, component: ChatListPage },
];
